/**
 * Robust external-link opener.
 *
 * Some third-party pages (WhatsApp, Google, LinkedIn, etc.) send `X-Frame-Options`
 * headers that prevent them from loading inside an iframe / in-app browser. When
 * our site is viewed through an in-app browser (WhatsApp, LinkedIn preview, etc.)
 * a plain `target="_blank"` anchor can end up navigating INSIDE that iframe,
 * triggering an `ERR_BLOCKED_BY_RESPONSE` page.
 *
 * Explicitly calling `window.open(url, '_blank', 'noopener,noreferrer')` in a
 * click handler creates a top-level browsing context in the user's system
 * browser, which reliably escapes the in-app / iframed context.
 */
export function openExternal(url) {
  return (e) => {
    if (!url) return;
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    try {
      const w = window.open(url, '_blank', 'noopener,noreferrer');
      // Fallback: if popup was blocked, navigate the top-level window.
      if (!w) {
        if (window.top) {
          window.top.location.href = url;
        } else {
          window.location.href = url;
        }
      }
    } catch (_) {
      window.location.href = url;
    }
  };
}
